// extracted by mini-css-extract-plugin
var _1 = "styles_listOrderDetails__ZJ8nS";
var _2 = "styles_product__Qsb2r";
var _3 = "styles_productText__4pGaY";
var _4 = "styles_surprise__AvSqv";
export { _1 as "listOrderDetails", _2 as "product", _3 as "productText", _4 as "surprise" }
